export default "__VITE_ASSET__v9Q6sqOs__"